import { Grid2 } from '@mui/material'
import { useEffect } from 'react'
import { GRAY_COLORS } from 'asterX-UI'
import PageContainer from 'components/PageContainer/PageContainer'
import { useAuthStore } from 'context/AuthStore'
import { useHomeStore } from 'context/HomeStore'
import { Pagination } from 'asterX-UI/Pagination'
import { Filter } from 'components/Filter'
import StandardTable from 'asterX-UI/Table/StandardTable'
import Header from 'components/Header/Header'
import { useNavigate } from 'react-router'
import {
  ACCOUNTANT,
  DICT_ADMIN,
  HEAD_UNDERWRITER,
  MANAGER,
  SUPER_UNDERWRITER,
  UNDERWRITER
} from 'lib/constants/roles'
import Dashboard from 'components/Dashboard/Dashboard'
import { CreditFlow } from '../../lib/api/services/creditFlow.service'
import { CookieService } from '../../lib/utils/services/cookie.service'
import AdminModal from '../../components/RoleModals/AdminModal/AdminModal'
import { getTableDataByRoleAndTab } from './home-constant'




const Home = () => {
  const { authStore } = useAuthStore()
  const { homeStore, homeStoreFunc } = useHomeStore()
  const navigate = useNavigate()

  const isDictionaryRole = authStore.isUserRole === DICT_ADMIN

  const tableData = getTableDataByRoleAndTab(
    authStore.isUserRole,
    {
      ...homeStore,
      ...(isDictionaryRole && {
        onOpenModal: homeStoreFunc.openAdminModal,
        tab: homeStore.tab
      })

    }
  )



  const handleRowClick = row => {
    let current
    const rowData = row.find(item => item?.isButton)
    if (!rowData?.id) return
    if (homeStore.tab === 'clients') {
      current = homeStore.listData.find(e => e?.id === rowData.id)
    } else {
      current = homeStore.listData.find(e => e?.id === rowData.id)
    }

    if (!current) return

    if (isDictionaryRole && ['groups', 'dealers', 'locations'].includes(homeStore.tab)) {
      homeStoreFunc.openAdminModal('view', homeStore.tab, current)
      return
    }


    if (authStore.isUserRole === ACCOUNTANT) {
      return navigate(`/contract/${current?.loanApplication?.id}`)
    }

    if (
      authStore.isUserRole === MANAGER &&
      [null, 'userCreateLoanApplication', 'userCreateClientOTP'].includes(current?.status?.code)
    ) {
      return navigate(`/new-application/${current?.id}`)
    }

    const tabRoutes = {
      main: `/application/${current?.id}`,
      applications: `/application/${current?.id}`,
      contracts: `/contract/${current?.loanApplication?.id}`,
      clients: `/client/${current?.id}`,
      collaterals: `/collateral/${current?.id}`,
      ownApplications: `/application/${current?.id}`
    }

    const route = tabRoutes[homeStore.tab]
    if (route) navigate(route)
  }

  useEffect(() => {


    const contractId = CookieService.getCookie('redirectToCreditFlowByContract_ID');
    if (!contractId) return;


    const checkContractAndRedirect = async () => {
      try {
        const res = await CreditFlow.getContractList({ limit: 100, offset: 0 })
        const foundContract = res?.data?.list?.find(
          (item) => item?.id?.toString() === contractId?.toString()
        );
        if (foundContract) {
          CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
          navigate(`/contract/${foundContract.loanApplication.id}`);
        } else {
          console.warn('Контракт с таким ID не найден в списке');
          CookieService.deleteCookieEverywhere('redirectToCreditFlowByContract_ID');
        }
      } catch (e) {
        console.error('Ошибка при получении списка контрактов:', e);
      }
    };

    checkContractAndRedirect();
  }, []);





  const renderContentByRoleAndTab = () => {
    return (
      <>
        {[UNDERWRITER, HEAD_UNDERWRITER, SUPER_UNDERWRITER].includes(authStore.isUserRole) && <Dashboard />}

        <Filter />
        <StandardTable
          onRowClick={handleRowClick}
          tableData={tableData}
          tableStyles={{ border: `1px solid ${GRAY_COLORS[200]}` }}
          btnStyle={{ padding: 0, border: 'none' }}
        />
        <Grid2 size={{ xs: 12 }} sx={{ marginTop: 'auto' }}>
          <Pagination
            count={Math.ceil(homeStore?.pagination?.count / 30)}
            page={homeStore?.pagination?.offset + 1}
            onChange={homeStoreFunc.handlePaginationChange}
            isMobile={authStore.isMobile}
          />
        </Grid2>
      </>
    )
  }

  return (
    <PageContainer>
      {authStore.isUserRole !== ACCOUNTANT && <Header />}
      {renderContentByRoleAndTab()}
      {homeStore.adminModal.open && (
        <AdminModal
          open={homeStore.adminModal.open}
          onClose={homeStoreFunc.closeAdminModal}
          mode={homeStore.adminModal.mode}
          tab={homeStore.adminModal.tab}
          data={homeStore.adminModal.data}
          onSave={formData => {
            const { mode, tab } = homeStore.adminModal;
            if (mode === 'create') {
              homeStoreFunc.createDictionaryItem(tab, formData);
            } else if (mode === 'edit') {
              homeStoreFunc.updateDictionaryItem(tab, formData.id, formData);
            } else if (mode === 'delete') {
              homeStoreFunc.deleteDictionaryItem(tab, formData.id);
            }
          }}
        />
      )}
    </PageContainer>
  )
}

export default Home
